import React from 'react';
import '../../../../styles/table.admin.css';
import textStyles from './textStyle.module.css';
import './testStyles.css'


let TableComponent = (props) =>{
    const { dataPages, records, pages } = props
    
    const bufMap = []

    for(let key in records[0]){
        bufMap.push(
            <th key = {key}>
                {key}
            </th>
        )
    }

    const iterObj = (object) =>{
        const bufMap = [];
        for (let key in object) {
            bufMap.push(
                <td key = {key} >
                    {object[key]}
                </td>
            )
        }

        return bufMap.map(el => el)
    }

    return(
        <>
        <div className={textStyles.heading}>
                        Всего: {dataPages}
                    </div>
                    <div className={textStyles.heading}>
                        Текущая страница: {pages}, записей на странице: {records.length}
                    </div>
        <table className="table tableInfoAddress">
        <thead>
            <tr>
                { bufMap.map(el => el) }
            </tr>
        </thead>
        <tbody>
            {
                records.map((tx, index) => {
                    return (
                        <tr key={index}>{ iterObj(tx) } </tr>
                    )
                })
            }
        </tbody>
    </table>
    </>
    )
}

export default TableComponent;